import React from 'react';
import ShoppingCart from '../components/ShoppingCart'; // Ensure correct import path

function ShoppingCartPage() {
  return (
    <div className="container px-4 px-lg-5 mt-5">
      <ShoppingCart />

      {/* Payment Security and Logos */}
      <div className="text-center mt-5">
        <h5>Payments Secured by SQUARE</h5>
        <div className="d-flex justify-content-center align-items-center flex-wrap gap-3 mt-3">
          <img src="/assets/AmericanExpress.png" alt="American Express" height="40" />
          <img src="/assets/Discover.png" alt="Discover" height="30" />
          <img src="/assets/MasterCard.png" alt="MasterCard" height="25" />
          <img src="/assets/VISA.png" alt="VISA" height="20" />
        </div>
      </div>
    </div>
  );
}

export default ShoppingCartPage;

